export default "__VITE_ASSET__BZwEF23O__"